export default {
  download: 'Download Phocol',
}

